import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { SuratJalanBateraiListComponent } from './list/surat-jalan-baterai-list.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: SuratJalanBateraiListComponent,
            canActivate: [AuthorizationService],
            data: {
              name: ['suratJalanBaterai.read']
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuratJalanBateraiRoutingModule {}
